import { useLingui } from '@lingui/react/macro';

import { InputSelect, InputSelectProps } from '@/design_system/InputSelect/InputSelect';
import { Country, useCountries } from '@/services/i18n';

type InputCountryProps = {
  value?: string | null;
  onChange: (value: string | null) => void;
} & Omit<InputSelectProps<Country, false>, 'value' | 'onChange'>;

export const InputCountry = ({ placeholder, value, onChange, ...props }: InputCountryProps) => {
  const { t } = useLingui();
  const countries = useCountries();

  return (
    <InputSelect
      variant="select"
      placeholder={
        placeholder ?? t({ id: 'components.input-country.label', message: 'Select a country' })
      }
      options={countries}
      getOptionValue={(country) => country.name}
      getOptionLabel={(country) => country.name}
      value={countries.find((country) => country.code === value)}
      onChange={(country, action) => {
        if (action.action === 'clear') {
          onChange(null);
        } else if (country) {
          onChange(country.code);
        }
      }}
      autoComplete="country"
      isClearable
      {...props}
    />
  );
};
